<template>
    <div class="templete no_print">
      <div class="path_title clearfix">
        <span class="path_title_name">销售工作台公共客户池设置</span>
        <div class="contractLabel" style="position:relative;">
          <span class="redQuestion"></span>
          <div class="labelTip">
            <!-- <div class="laCbelTipC">注：默认100天以上未成交或未联系的客户划入公共客户池，提交修改后需重新进入销售工作台页面。</div> -->
            <div class="labelZhu">注:</div>
            <div class="laCbelTipC">
              1.系统默认最低值为30天（设置天数不能低于30天）
            </div>
            <div class="laCbelTipC">
              2.当您设置未联系天数为N时，销售员在N天之内没有联系过的客户，将被剥离归属人，划入客户公共池。
            </div>
            <div class="laCbelTipC">
              3.当您设置的未成交天数为M时，销售员在M天内未成交的客户将被剥离归属人，划入客户公共池。
            </div>
            <div class="laCbelTipC">
              4.当客户即使在N天之内被联系多次，但达到M天后依然未成交，还是会被剥离归属人，划入客户公共池。（培养新客户需要时间，未成交天数可以稍微设置长点）
            </div>
          </div>
        </div>
      </div> 
      <div class="wrap">
        <div class="input_box input_w">
          当前设置未联系天数为 {{showUncontactDay}}, 修改为
          <el-input class="input_i" v-model="uncontactDay" @blur="sumbitUncontactModify" @input="inputEventCallback_" maxlength="4" size="mini"></el-input>
          天
        </div>
      </div>
      <div class="wrap">
        <div class="input_box input_w">
          当前设置未成交天数为 {{showDay}}, 修改为
          <el-input class="input_i" v-model="day" @blur="sumbitUndealModify" @input="inputEventCallback" maxlength="4" size="mini"></el-input>
          天
        </div>
        <div class="path_switch">
          <el-radio-group v-model="radio" @change="timeChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </div>
        <div class="path_button">
            <el-button  class="publicBtn" @click="flushTime()">重置开启时间</el-button>
        </div>
      </div>
      <el-dialog v-dialog-drag :visible.sync="dialogVisible" modal width="500px" top="25vh">
          <div style="text-align: left;"><strong style="color: #b21111">注：</strong>1. 系统默认最低值为30天（设置天数不能低于30天）</div>
          <div style="text-align: left;padding-left: 28px;margin-top: 10px;">2. 当您设置未联系天数为N时，销售员在N天之内没有联系过的客户，将被剥离归属人，划入客户公共池。</div>
          <div style="text-align: left;padding-left: 28px;margin-top: 10px;"> 3. 当您设置的未成交天数为M时，销售员在M天内未成交的客户将被剥离归属人，划入客户公共池。</div>     
          <div style="text-align: left;padding-left: 28px;margin-top: 10px;"> 4. 当客户即使在N天之内被联系多次，但达到M天后依然未成交，还是会被剥离归属人，划入客户公共池。（培养新客户需要时间，未成交天数可以稍微设置长点）</div>    
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" size="mini" style="color: #b21111;border-color: #b21111;background-color: #ffffff;">我知道了</el-button>
          </span>
      </el-dialog>
    </div>
</template>

<script>
export default {
  data() {
    return {
      module:localStorage.dw_erp_power_code,
      day: '', //未成交输入值
      uncontactDay: '', //未联系输入值
      showDay: 100,
      showUncontactDay: 100,
      radio: 0,
      unDealID: '',
      unContactID: '',
      dialogVisible: true
    }
  },
  methods: {
    //未成交输入框 失焦事件
    sumbitUndealModify(){
      if(this.day == '') return;
      if(this.day < 30){
        this.tip("未成交天数设置不能少于30天", 'warning')
        return
      }  
      this.postFunc("/erp/customer.config.set", {id: this.unDealID, type: 2, value: + this.day}, ()=>{
        this.day = ''
        this.getCustomerConfigList()
        this.tip("修改成功", 'success')
      })
    },
   //未联系输入框 失焦事件
    sumbitUncontactModify(){
      if(this.uncontactDay == '') return ;
      if(this.uncontactDay < 30){
        this.tip("未联系天数设置不能少于30天", 'warning')
        return
      }  
      this.postFunc("/erp/customer.config.set", {id: this.unContactID, type: 1, value: + this.uncontactDay}, ()=>{
        this.uncontactDay = ''
        this.getCustomerConfigList()
        this.tip("修改成功", 'success')
      })
    },
    //获取客户配置列表
    getCustomerConfigList(){
      this.postFunc("/erp/customer.config.list", {}, res=>{
        let resData = res.data.data  
        resData.forEach(item => {
          if(item.type == 2){
            this.unDealID = item.id
              this.showDay = item.value ? item.value : 100
          }
          if(item.type == 1){
            this.unContactID = item.id
             this.showUncontactDay = item.value ? item.value : 100
          }
        });  
        this.radio = resData[0].status
      })
    },
    inputEventCallback(){
      let reg = new RegExp("^[1-9]\\d{0,2}");
      if(!reg.test(this.day)){
        this.day = ''
      }    
    },
    inputEventCallback_(){
      let reg = new RegExp("^[1-9]\\d{0,2}");
      if(!reg.test(this.uncontactDay)){
        this.uncontactDay = ''
      }    
    },
    timeChange(){
      this.postFunc("/erp/customer.config.set", {status: + this.radio}, res=>{
        window.console.log(res)
        this.tip("操作成功", 'success')
      })
    },
    flushTime(){
      this.$confirm('是否确定重置开启时间?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
			}).then(() => {
          this.postFunc("/erp/customer.reset.time", {}, res=>{
            window.console.log(res)
            this.tip("操作成功", 'success')
          })
      }).catch(()=>{});
    }
  },
  mounted(){
    this.getCustomerConfigList()
  }
};
</script>

<style lang="scss" scoped>
.contractLabel {
  float: left;
  position: relative;
  top: 3px;
  margin-left: 10px;
}
.path_title_name {
  float: left;
}
.redQuestion {
  display: block;
  width: 15px;
  height: 15px;
  background: url("/icon/question.png") no-repeat 100%;
  background-size: 100% 100%;
}
.labelTip {
  display: none;
  position: absolute;
  top: 20px;
  left: -150px;
  z-index: 1;
  width: 250px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 1px 1px 5px #ccc;padding-left:30px;
}
.laCbelTipC {
  color: #606266;
  font-size: 12px;
}
.labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
.contractLabel:hover {
  cursor: pointer;
}
.contractLabel:hover .labelTip {
  display: block;
}
.path_title {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  margin-top: 26px;
  margin-bottom: 20px;
  & + div {
    margin-bottom: 20px;
    color: #333333;
    display: flex;
    align-items: center;
  }
}
.wrap {
  text-align: left;
  font-size: 16px;
  .input_box {
    width: 100px;
    display: inline-block;
  }
  .input_w {
    width: 820px;
    .input_i {
      display: inline-block;
      width: 80px;
    }
  }
  .path_switch{
    text-align: left;
    margin-top:20px;
  }
  .path_button{
    text-align: left;
    margin-top:20px;
  }
  // .btn_box{
  //   display: block;
  //   margin-top: 10px;
  // }
}
.wrap /deep/ .el-input__inner {
  padding: 0 0 0 15px;
}
</style>